module.exports = __webpack_public_path__ + "img/web_tutorial03.b1ecebf9.jpg";